import { defineStore } from 'pinia'
import axios from 'axios'

let timer

// Helper global para datos del usuario (manteniendo compatibilidad)
export const userHelper = {
  userData: null,
  getUserData() {
    return this.userData
  },
  setUserData(data) {
    this.userData = data
  }
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    menu: null,
    token: null,
    tokenExpiration: null,
    tokenRefresh: null,
    didAutoLogout: false,
    loggedIn: false,
    messageLogin: null
  }),

  getters: {
    gettersMenu: (state) => state.menu,
    getToken: (state) => state.token,
    tokenExp: (state) => state.tokenExpiration,
    tokenRef: (state) => state.tokenRefresh,
    isAuthenticated: (state) => !!state.token,
    isAutoLogout: (state) => state.didAutoLogout,
    isMessageLogin: (state) => state.messageLogin
  },

  actions: {
    async sendLogin(payload) {
      const url = '/login-web'
      
      try {
        const response = await axios.post(url, payload)
        const { data: { token, user, customer, products, sysconf, suppliers, numeration } } = response.data

        console.log(token)
        
        // Configurar header de autorización
        axios.defaults.headers.common.Authorization = `Bearer ${token}`

        const expiresIn = 340025 * 1000
        const expirationDate = new Date(expiresIn)
        
        console.log(expirationDate.getTime())

        // Guardar en sessionStorage
        sessionStorage.setItem('token', token)
        sessionStorage.setItem('user', JSON.stringify(user))
        sessionStorage.setItem('customer', JSON.stringify(customer))
        sessionStorage.setItem('products', JSON.stringify(products))
        sessionStorage.setItem('sysconf', JSON.stringify(sysconf))
        sessionStorage.setItem('loggedIn', true)
        sessionStorage.setItem('suppliers', JSON.stringify(suppliers))
        sessionStorage.setItem('numeration', JSON.stringify(numeration))
        sessionStorage.setItem('tokenExpiration', JSON.stringify(expirationDate))

        // Guardar datos del usuario en helper global
        userHelper.setUserData(user)

        // Actualizar estado
        this.setToken({
          token,
          tokenExpiration: expirationDate
        })

        return true
      } catch (error) {
        axios.defaults.headers.common.Authorization = null
        
        const errorLogin = new Error(
          error.message || 'Failed to authenticate. Check your login data.'
        )
        
        console.log(errorLogin.message)
        
        if (errorLogin.message === 'Request failed with status code 404') {
          this.setMessageLogin('Usuario o Contraseña inválidos')
        }
        
        throw errorLogin
      }
    },

    tryVeryLogin() {
      const token = sessionStorage.getItem('token')
      const tokenExpiration = sessionStorage.getItem('tokenExpiration')
      const loggedIn = sessionStorage.getItem('loggedIn')
      const expiresIn = +tokenExpiration - new Date().getTime()

      if (token) {
        axios.defaults.headers.common.Authorization = `Bearer ${token}`
        
        // Cargar datos del usuario en helper global
        const userData = sessionStorage.getItem('user')
        if (userData) {
          userHelper.setUserData(JSON.parse(userData))
        }

        this.setToken({
          token,
          tokenExpiration
        })
      }
    },

    async MenuUser() {
      const url = `/permisos/menu-user`
      
      try {
        const response = await axios.get(url)
        
        sessionStorage.setItem('menu', JSON.stringify(response.data))
        
        this.setMenu(response.data)
      } catch (error) {
        const errorLogin = new Error(
          error.message || 'Failed to authenticate. Check your login data.'
        )
        
        if (errorLogin.message === 'Request failed with status code 401') {
          this.autoLogout()
        }
        
        throw errorLogin
      }
    },

    async tryMenuUser() {
      try {
        const data = sessionStorage.getItem('menu')
        
        if (data) {
          this.setMenu(JSON.parse(data))
        }
      } catch (error) {
        const errorLogin = new Error(
          error.message || 'Failed to authenticate. Check your login data.'
        )
        
        if (errorLogin.message === 'Request failed with status code 401') {
          this.autoLogout()
        }
        
        throw errorLogin
      }
    },

    getLogout() {
      // Limpiar sessionStorage
      const itemsToRemove = [
        'token', 'tokenExpiration', 'data_menus', 'invoicesLists',
        'reception_lists', 'productLists', 'menu', 'userSession',
        'receptionLists', 'titles', 'edit_menu', 'data_roles',
        'customerLists', 'info_sysconf', 'data_users', 'sysconf',
        'reception_Lists', 'loggedIn', 'user', 'customer', 'products',
        'suppliers', 'numeration'
      ]
      
      itemsToRemove.forEach(item => {
        sessionStorage.removeItem(item)
      })

      // Limpiar datos del usuario en helper global
      userHelper.setUserData(null)

      console.log('si llego')
      clearTimeout(timer)

      delete axios.defaults.headers.common.Authorization
      
      this.setLogout()
    },

    autoLogout() {
      this.getLogout()
      this.setAutoLogout()
    },

    // Mutations convertidas a métodos
    setToken(payload) {
      this.token = payload.token
      this.tokenExpiration = payload.tokenExpiration
      this.didAutoLogout = false
      this.loggedIn = true
    },

    setMenu(menu) {
      this.menu = menu
    },

    setAutoLogout() {
      this.didAutoLogout = true
      this.loggedIn = false
    },

    setMessageLogin(message) {
      this.messageLogin = message
    },

    setLogout() {
      this.token = null
      this.didAutoLogout = true
      this.loggedIn = false
    }
  }
})